<template>
    <div id="verification"
         class="verification">
        <h3>Verification</h3>
        <uploaded-files></uploaded-files>
        <edit-data v-if="!checkUserData"></edit-data>
        <upload-files v-if="checkUserData && !isVerified"></upload-files>
    </div>
</template>

<script>
    import EditData from './verification/EditData.vue'
    import UploadFiles from './verification/UploadFiles.vue'
    import UploadedFiles from './verification/UploadedFiles.vue'

    export default {
        components: { EditData, UploadFiles, UploadedFiles },
        computed: {
            checkUserData () {
                let filled = true
                for (const index in this.userData) {
                    if (this.userData[index] == '' || !this.userData[index]) {
                        filled = false
                        break
                    }
                    if (!filled) break
                }
                return filled
            },
            isVerified () {
                let verified   = this.$store.getters.user.isVerified,
                    inProgress = this.$store.getters.verificationFiles.filter(function(obj){
                        return obj.status === 'accepted' || obj.status === 'new'
                    })

                return verified || inProgress.length > 0
            },
            userData () {
                return {
                    email: this.$store.getters.user.email,
                    firstname: this.$store.getters.user.firstName,
                    lastname: this.$store.getters.user.lastName,
                    street: this.$store.getters.user.street,
                    city: this.$store.getters.user.city,
                    zip: this.$store.getters.user.postalCode,
                    birthdate: this.$store.getters.user.birthDate,
                    phone: this.$store.getters.user.phoneNumber,
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../../../assets/scss/_colors.scss';

    .verification{
        margin: 33px 0;
        padding: 16px;
        border: 6px solid $base1;

        h3{
            color: $base1;
            font-weight: bold;
            margin: 0;
        }

        button,
        .col,
        a.button--primary{
            display: block;
            margin-top:10px;
        }

        button{
            width: 100%;
        }

        .row p{
            margin-top: 18px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/partials/section/content/profile/Verification.vue